import * as deepmerge from 'deepmerge';
var ValidationErrorHandler = /** @class */ (function () {
    function ValidationErrorHandler() {
        this.errors = null;
    }
    /**
     * Adds a validation error for the whole form.
     *
     * @param key a property name that is not defined in `DefaultKeys` (validation-error-map.ts)
     * @param value a `{key:string, parameters?: any}` for translation
     * @param predicate if true the validation error will be added
     */
    ValidationErrorHandler.prototype.addError = function (key, value, predicate) {
        if (predicate === void 0) { predicate = true; }
        if (predicate) {
            if (this.errors == null) {
                this.errors = {};
            }
            this.errors[key] = deepmerge(this.errors[key], value);
        }
        return this;
    };
    ValidationErrorHandler.prototype.addErrors = function (errors, parent) {
        var _this = this;
        if (errors != null) {
            if (parent != null) {
                // Ensure that the error field is an object
                if (this.errors == null) {
                    this.errors = {};
                }
                // Ensure the property at ${parent} is an object
                if (this.errors[parent] == null) {
                    this.errors[parent] = {};
                }
                // Add all fields that have errors
                Object.keys(errors).forEach(function (key) {
                    _this.errors[parent][key] = errors[key];
                });
            }
            else {
                Object.keys(errors).forEach(function (key) {
                    _this.addError(key, { key: key, value: errors[key] }, true);
                });
            }
        }
    };
    ValidationErrorHandler.prototype.getErrors = function () {
        return this.errors;
    };
    ValidationErrorHandler.prototype.hasErrors = function () {
        return this.errors !== null;
    };
    ValidationErrorHandler.prototype.isValid = function () {
        return this.hasErrors() === false;
    };
    return ValidationErrorHandler;
}());
export { ValidationErrorHandler };
//# sourceMappingURL=data:application/json;base64,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